import { Pagination } from "./pagination";

export interface Budget {
  id: string;
  total: string;
  subtotal: string;
  total_with_discount: number;
  observations: string;
  status: string;
  user: User;
  patient: Patient;
  procedures: Procedure[];
  voucher: Voucher;
  created_at: string;
}

interface Procedure {
  id: string;
  name: string;
  procedure_real_value: number;
  quantity_sessions: number;
  session_value: string;
  total: string;
  employee: Employee;
}

interface User {
  id: string;
  name: string;
}

interface Patient {
  id: string;
  name: string;
}

interface Employee {
  id: string;
  name: string;
}

export interface CreateBudgetRequestDTO {
  patient_id: string;
  observations?: string | null;
  status?: string;
  procedures: RequestProcedure[];
}

export interface UpdateBudgetRequestDTO {
  id: string;
  patient_id: string;
  observations?: string | null;
  status: string;
  procedures: RequestProcedure[];
}

export enum BudgetStatusEnum {
  APPROVED = "approved",
  FINISHED = "finished",
  CANCELED = "canceled",
  PENDING = "pending",
}

export interface UpdateBudgetStatusRequestDTO {
  id: string;
  status?: BudgetStatusEnum;
}

interface RequestProcedure {
  id: string;
  quantity: number;
  value: number;
  employee_id: string;
}

export type RequestBudgetResponse = Budget;

interface Procedure {
  id: string;
  name: string;
  procedure_real_value: number;
  quantity_sessions: number;
  session_value: string;
  total: string;
  employee: User;
}

interface User {
  id: string;
  name: string;
}

type Voucher = {
  id: string;
  code: string;
  value: string;
  type: string;
  discount: number;
  expires_at: string;
  is_expired: string;
  created_at: string;
  updated_at: string;
};

export interface BudgetResponse {
  items: Budget[];
  data: Pagination;
}
